export const GetDeeplinkDestination = (route) => ({
  Orlando: {
    name: "Orlando",
    route,
    state: {
      default_airport: "MCO - Orlando International Airport - Orlando, United States",
      destination: "Orlando,FL,US",
      lat: "28.554109573364258",
      lon: "-81.379638671875",
    },
  },
  Austin: {
    name: "Austin",
    route,
    state: {
      destination: "Austin,TX,US",
      lat: "30.220590591430664",
      lon: "-97.68816375732422",
    },
  },
  SanDiego: {
    name: "San Diego",
    route,
    state: {
      destination: "San%20Diego,CA,US",
      lat: "32.70978927612305",
      lon: "-117.1418685913086",
    },
  },
  Seattle: {
    name: "Seattle",
    route,
    state: {
      destination: "Seattle,WA,US",
      lat: "47.61009979248047",
      lon: "-122.34075927734375",
    },
  },
  LasVegas: {
    name: "Las Vegas",
    route,
    state: {
      destination: "Las%20Vegas,NV,US",
      lat: "36.1699",
      lon: "-115.1398",
    },
  },
  SanFrancisco: {
    name: "San Francisco",
    route,
    state: {
      destination: "San%20Francisco,CA,US",
      lat: "37.77629852294922",
      lon: "-122.41815185546875",
    },
  },
  Chicago: {
    name: "Chicago",
    route,
    state: {
      destination: "Chicago,IL,US",
      lat: "41.881832",
      lon: "-87.623177",
    },
  },
  Amsterdam: {
    name: "Amsterdam",
    route,
    state: { destination: "Amsterdam", lat: "52.377956", lon: "4.897070" },
  },
  PanamaCityBeach: {
    name: "Panama City Beach",
    route,
    state: {
      destination: "Panama%20City%20Beach,FL,US",
      lat: "21.1619",
      lon: "-86.8515",
    },
  },
  Cancun: {
    name: "Cancún",
    route,
    state: {
      destination: "Cancún,MX",
      lat: "21.1619",
      lon: "-86.8515",
    },
  },
  LosAngeles: {
    name: "Los Angeles",
    route,
    state: {
      destination: "Los%20Angeles,CA,US",
      lat: "34.052235",
      lon: "-118.243683",
    },
  },
  PuertoVallarta: {
    name: "Puerto Vallarta",
    route,
    state: {
      destination: "Puerto%20Vallarta,MX",
      lat: "37.77629852294922",
      lon: "-122.41815185546875",
    },
  },
  Toronto: {
    name: "Toronto",
    route,
    state: {
      destination: "Toronto,CA",
      lat: "43.651070",
      lon: "-79.347015",
    },
  },
  Atlanta: {
    name: "Atlanta",
    route,
    state: { destination: "Atlanta,GA,US", lat: "52.377956", lon: "4.897070" },
  },
  Hawaii: {
    name: "Hawaii",
    route,
    state: { destination: "Hawaii,US", lat: "19.741755", lon: "-155.844437" },
  },
  CaboSanLucas: {
    name: "Cabo San Lucas",
    route,
    state: {
      destination: "Cabo%20San%20Luxas,MX",
      lat: "22.890533",
      lon: "-109.916740",
    },
  },
  Nashville: {
    name: "Nashville",
    route,
    state: {
      destination: "Nashville,TN,US",
      lat: "36.14046096801758",
      lon: "-86.78720092773438",
    },
  },
  NewOrleans: {
    name: "New Orleans",
    route,
    state: {
      destination: "New%20Orleans,LA,US",
      lat: "29.952909469604492",
      lon: "-90.07404327392578",
    },
  },
  NewYork: {
    name: "New York",
    route,
    state: {
      default_airport: "JFK - John F Kennedy International Airport - New York, United States",
      destination: "New%20York,NY,US",
      lat: "40.712",
      lon: "-74.0060",
    },
  },
  Oahu: {
    name: "Oahu",
    route,
    state: { destination: "Oahu,HI,US", lat: "21.4389", lon: "-158.0001" },
  },
  Miami: {
    name: "Miami",
    route,
    state: {
      destination: "Miami,FL,US",
      lat: "25.768659591674805",
      lon: "-80.18872833251953",
    },
  },
});
